import tinycolor from "tinycolor2";

/**
 * Recursively traverses up the DOM tree to find a solid background color.
 *
 * Features:
 * - Searches for background colors without transparency
 * - Recursively checks parent elements until solid color is found
 * - Handles transparent and semi-transparent backgrounds
 * - Returns hex8 color format for consistency
 * - Checks both background-color and opacity properties
 * - Provides fallback to transparent black if no solid background found
 * - Uses tinycolor2 for accurate color analysis
 * - Handles edge cases like missing parent elements
 *
 * Algorithm:
 * 1. Gets computed style of current element
 * 2. Checks if background color has full opacity (alpha = 1)
 * 3. Verifies element opacity is also 1
 * 4. If solid, returns hex8 color string
 * 5. If transparent, recursively checks parent element
 * 6. Returns transparent black if no solid background found
 *
 * @param node - The DOM element to start searching from
 * @returns Hex8 color string representing the solid background, or transparent black if none found
 */
export function getSolidBackground(node: Element) {
  const style = getComputedStyle(node);
  const bg = style.backgroundColor;

  if (tinycolor(bg).getAlpha() === 1 && style.opacity === "1") {
    return tinycolor(bg).toHex8String();
  }

  if (!node.parentElement) {
    return tinycolor("rgba(0, 0, 0, 0)").toHex8String();
  }

  getSolidBackground(node.parentElement);
}
